import React, { createContext } from "react";

export const SerieContext = createContext();

const SerieProvider = ({ children }) => {
  const TopSerie = [
    {
      backdrop_path: "/99vBORZixICa32Pwdwj0lWcr8K.jpg",
      first_air_date: "2021-09-03",
      genre_ids: [10764],
      id: 130392,
      name: "The D'Amelio Show",
      origin_country: ["US"],
      original_language: "en",
      original_name: "The D'Amelio Show",
      overview:
        "From relative obscurity and a seemingly normal life, to overnight success and thrust into the Hollywood limelight overnight, the D’Amelios are faced with new challenges and opportunities they could not have imagined.",
      popularity: 12.758,
      poster_path: "/phv2Jc4H8cvRzvTKb9X1uKMboTu.jpg",
      vote_average: 8.9,
      vote_count: 3186,
    },
    {
      backdrop_path: "/hwIAR9FDsKULo8efoOUuxsFtO2u.jpg",
      first_air_date: "2008-01-20",
      genre_ids: [18],
      id: 1396,
      name: "Breaking Bad",
      origin_country: ["US"],
      original_language: "en",
      original_name: "Breaking Bad",
      overview:
        "When Walter White, a New Mexico chemistry teacher, is diagnosed with Stage III cancer and given a prognosis of only two years left to live. He becomes filled with a sense of fearlessness and an unrelenting desire to secure his family's financial future at any cost as he enters the dangerous world of drugs and crime.",
      popularity: 442.868,
      poster_path: "/ggFHVNu6YYI5L9pCfOacjizRGt.jpg",
      vote_average: 8.9,
      vote_count: 11316,
    },
    {
      backdrop_path: "/uDgy6hyPd82kOHh6I95FLtLnj6p.jpg",
      first_air_date: "2023-01-15",
      genre_ids: [18],
      id: 100088,
      name: "The Last of Us",
      origin_country: ["US"],
      original_language: "en",
      original_name: "The Last of Us",
      overview:
        "Twenty years after modern civilization has been destroyed, Joel, a hardened survivor, is hired to smuggle Ellie, a 14-year-old girl, out of an oppressive quarantine zone. What starts as a small job soon becomes a brutal, heartbreaking journey, as they both must traverse the United States and depend on each other for survival.",
      popularity: 3208.756,
      poster_path: "/uKvVjHNqB5VmOrdxqAt2F7J78ED.jpg",
      vote_average: 8.8,
      vote_count: 2771,
    },
    {
      backdrop_path: "/rkB4LyZHo1NHXFEDHl9vSD9r1lI.jpg",
      first_air_date: "2021-11-06",
      genre_ids: [16, 10765, 10759, 18],
      id: 94605,
      name: "Arcane",
      origin_country: ["US"],
      original_language: "en",
      original_name: "Arcane",
      overview:
        "Amid the stark discord of twin cities Piltover and Zaun, two sisters fight on rival sides of a war between magic technologies and clashing convictions.",
      popularity: 72.927,
      poster_path: "/fqldf2t8ztc9aiwn3k6mlX3tvRT.jpg",
      vote_average: 8.7,
      vote_count: 2947,
    },
    {
      backdrop_path: "/uGy4DCmM33I7l86W7iCskNkvmLD.jpg",
      first_air_date: "2013-12-02",
      genre_ids: [16, 35, 10765, 10759],
      id: 60625,
      name: "Rick and Morty",
      origin_country: ["US"],
      original_language: "en",
      original_name: "Rick and Morty",
      overview:
        "Rick is a mentally-unbalanced but scientifically gifted old man who has recently reconnected with his family. He spends most of his time involving his young grandson Morty in dangerous, outlandish adventures throughout space and alternate universes. Compounded with Morty's already unstable family life, these events cause Morty much distress at home and school.",
      popularity: 485.181,
      poster_path: "/cvhNj9eoRBe5SxjCbQTkh05UP5K.jpg",
      vote_average: 8.7,
      vote_count: 8005,
    },
    {
      backdrop_path: "/4Mt7WHox67uJ1yErwTBFcV8KWgG.jpg",
      first_air_date: "1999-10-20",
      genre_ids: [10759, 35, 16],
      id: 37854,
      name: "One Piece",
      origin_country: ["JP"],
      original_language: "ja",
      original_name: "ワンピース",
      overview:
        'Years ago, the fearsome Pirate King, Gol D. Roger was executed leaving a huge pile of treasure and the famous "One Piece" behind. Whoever claims the "One Piece" will be named the new King of the Pirates.\n\nMonkey D. Luffy, a boy who consumed a "Devil Fruit," decides to follow in the footsteps of his idol, the pirate Shanks, and find the One Piece. It helps, of course, that his body has the properties of rubber and that he\'s surrounded by a bevy of skilled fighters and thieves to help him along the way.\n\nLuffy will do anything to get the One Piece and become King of the Pirates!',
      popularity: 155.652,
      poster_path: "/e3NBGiAifW9Xt8xD5tpARskjccO.jpg",
      vote_average: 8.7,
      vote_count: 3644,
    },
    {
      backdrop_path: "/70YdbMELM4b8x8VXjlubymb2bQ0.jpg",
      first_air_date: "2017-03-19",
      genre_ids: [18, 10751],
      id: 70785,
      name: "Anne with an E",
      origin_country: ["CA"],
      original_language: "en",
      original_name: "Anne with an E",
      overview:
        "A coming-of-age story about an outsider who, against all odds and numerous challenges, fights for love and acceptance and for her place in the world. The series centers on a young orphaned girl in the late 1890’s, who, after an abusive childhood spent in orphanages and the homes of strangers, is mistakenly sent to live with an elderly woman and her aging brother. Over time, 13-year-old Anne will transform their lives and eventually the small town in which they live with her unique spirit, fierce intellect and brilliant imagination.",
      popularity: 98.015,
      poster_path: "/6P6tXhjT5tK3qOXzxF9OMLlG7iz.jpg",
      vote_average: 8.7,
      vote_count: 4225,
    },
    {
      backdrop_path: "/5DUMPBSnHOZsbBv81GFXZXvDpo6.jpg",
      first_air_date: "2022-10-12",
      genre_ids: [16, 10759, 10765, 35],
      id: 114410,
      name: "Chainsaw Man",
      origin_country: ["JP"],
      original_language: "ja",
      original_name: "チェンソーマン",
      overview:
        "Denji has a simple dream—to live a happy and peaceful life, spending time with a girl he likes. This is a far cry from reality, however, as Denji is forced by the yakuza into killing devils in order to pay off his crushing debts. Using his pet devil Pochita as a weapon, he is ready to do anything for a bit of cash.",
      popularity: 461.456,
      poster_path: "/npdB6eFzizki0WaZ1OvKcJrWe97.jpg",
      vote_average: 8.7,
      vote_count: 946,
    },
    {
      backdrop_path: "/2UG177tWHy7xRmMKWJHB7nAUmKd.jpg",
      first_air_date: "2009-04-05",
      genre_ids: [10759, 16, 10765],
      id: 31911,
      name: "Fullmetal Alchemist: Brotherhood",
      origin_country: ["JP"],
      original_language: "ja",
      original_name: "鋼の錬金術師 FULLMETAL ALCHEMIST",
      overview:
        "Edward and Alphonse Elric's reckless disregard for alchemy's fun­damental laws ripped half of Ed's limbs from his body and left Al's soul clinging to a cold suit of armor. To restore what was lost, the brothers scour a war-torn land for the Philosopher's Sto­ne, a fabled relic which grants the ability to perform alchemy in impossible ways.\n\nThe Elrics are not alone in their search; the corrupt State Military is also eager to harness the artifact's power. So too are the strange Homunculi and their shadowy creator. The mythical gem lures exotic alchemists from distant kingdoms, scarring some deeply enough to inspire murder. As the Elrics find their course altered by these enemies and allies, their purpose remains unchanged – and their bond unbreakable.",
      popularity: 106.785,
      poster_path: "/5ZFUEOULaVml7pQuXxhpR2SmVUw.jpg",
      vote_average: 8.7,
      vote_count: 1590,
    },
    {
      backdrop_path: "/6UH52Fmau8RPsMAbQbjwN3wJSCj.jpg",
      first_air_date: "2021-03-25",
      genre_ids: [16, 10765, 10759, 18],
      id: 95557,
      name: "Invincible",
      origin_country: ["US"],
      original_language: "en",
      original_name: "Invincible",
      overview:
        "Mark Grayson is a normal teenager except for the fact that his father is the most powerful superhero on the planet. Shortly after his seventeenth birthday, Mark begins to develop powers of his own and enters into his father’s tutelage.",
      popularity: 73.301,
      poster_path: "/yDWJYRAwMNKbIYT8ZB33qy84uzO.jpg",
      vote_average: 8.7,
      vote_count: 3420,
    },
    {
      backdrop_path: "/smSbK5cd8T9XHcxEUcems23BDEF.jpg",
      first_air_date: "2016-12-02",
      genre_ids: [18, 10765, 35],
      id: 67915,
      name: "Goblin",
      origin_country: ["KR"],
      original_language: "ko",
      original_name: "쓸쓸하고 찬란하神-도깨비",
      overview:
        "In his quest for a bride to break his immortal curse, a 939-year-old guardian of souls meets a grim reaper and a sprightly student with a tragic past.",
      popularity: 105.403,
      poster_path: "/fcWXmbHLf7u5egs6t5JdrsUwVIz.jpg",
      vote_average: 8.7,
      vote_count: 2450,
    },
    {
      backdrop_path: "/3ILMlmC30QUnYkY3XEBOyJ82Dqu.jpg",
      first_air_date: "2016-04-03",
      genre_ids: [10759, 16],
      id: 65930,
      name: "My Hero Academia",
      origin_country: ["JP"],
      original_language: "ja",
      original_name: "僕のヒーローアカデミア",
      overview:
        "In a world where eighty percent of the population has some kind of super-powered Quirk, Izuku was unlucky enough to be born completely normal. But that won't stop him from enrolling in a prestigious hero academy. Now, he'll get his first taste of brutal rivalry from other schools as he braves the cutthroat, no-holds-barred provisional license exam.",
      popularity: 126.347,
      poster_path: "/ivOLM47yJt90P19RH1NvJrAJz9F.jpg",
      vote_average: 8.7,
      vote_count: 4231,
    },
    {
      backdrop_path: "/iBAtBLqCMON3NPIjyQ1wdMbpTAk.jpg",
      first_air_date: "2019-04-06",
      genre_ids: [16, 10765, 10759],
      id: 85937,
      name: "Demon Slayer: Kimetsu no Yaiba",
      origin_country: ["JP"],
      original_language: "ja",
      original_name: "鬼滅の刃",
      overview:
        "It is the Taisho Period in Japan. Tanjiro, a kindhearted boy who sells charcoal for a living, finds his family slaughtered by a demon. To make matters worse, his younger sister Nezuko, the sole survivor, has been transformed into a demon herself. Though devastated by this grim reality, Tanjiro resolves to become a “demon slayer” so that he can turn his sister back into a human, and kill the demon that massacred his family.",
      popularity: 160.35,
      poster_path: "/wrCVHdkBlBWdJUZPvnJWcBRuhSY.jpg",
      vote_average: 8.7,
      vote_count: 4900,
    },
    {
      backdrop_path: "/dJ8yrSokdTMnhKJw06MllSfCegb.jpg",
      first_air_date: "2019-01-12",
      genre_ids: [16, 35, 18],
      id: 83121,
      name: "Kaguya-sama: Love Is War",
      origin_country: ["JP"],
      original_language: "ja",
      original_name: "かぐや様は告らせたい～天才たちの恋愛頭脳戦～",
      overview:
        "Considered a genius due to having the highest grades in the country, Miyuki Shirogane leads the prestigious Shuchiin Academy's student council as its president, working alongside the beautiful and wealthy vice president Kaguya Shinomiya. The two are often regarded as the perfect couple by students despite them not being in any sort of romantic relationship.",
      popularity: 74.645,
      poster_path: "/5khbC6AuNgnvnoDbjIMKCOhEtIc.jpg",
      vote_average: 8.7,
      vote_count: 596,
    },
    {
      backdrop_path: "/2vbE9ajftJ7dkqUAyxDS0WFILx8.jpg",
      first_air_date: "2010-09-06",
      genre_ids: [16, 35],
      id: 31132,
      name: "Regular Show",
      origin_country: ["US"],
      original_language: "en",
      original_name: "Regular Show",
      overview:
        "Two bored groundskeepers, Mordecai (a six-foot-tall blue jay) and Rigby (a hyperactive raccoon) are best friends who spend their days trying to entertain themselves by any means necessary, much to the displeasure of their boss. Their everyday pursuits often lead to things spiraling out of control and into the surreal.",
      popularity: 339.546,
      poster_path: "/mS5SLxMYcKfUxA0utBSR5MOAWWr.jpg",
      vote_average: 8.7,
      vote_count: 1669,
    },
    {
      backdrop_path: "/nLKYAJCEi6OQVji1HJIxSQ74H9s.jpg",
      first_air_date: "2005-02-21",
      genre_ids: [16, 10759, 10765],
      id: 246,
      name: "Avatar: The Last Airbender",
      origin_country: ["US"],
      original_language: "en",
      original_name: "Avatar: The Last Airbender",
      overview:
        "In a war-torn world of elemental magic, a young boy reawakens to undertake a dangerous mystic quest to fulfill his destiny as the Avatar, and bring peace to the world.",
      popularity: 59.033,
      poster_path: "/cHFZA8Tlv03nKTGXhLOYOLtqoSm.jpg",
      vote_average: 8.7,
      vote_count: 3187,
    },
    {
      backdrop_path: "/cHyY5z4txdVyGtYMvBJhCqCcJso.jpg",
      first_air_date: "2020-01-10",
      genre_ids: [16, 10765, 10751, 10759, 35],
      id: 92685,
      name: "The Owl House",
      origin_country: ["US"],
      original_language: "en",
      original_name: "The Owl House",
      overview:
        "An animated fantasy-comedy series that follows Luz, a self-assured teenage girl who accidentally stumbles upon a portal to a magical world where she befriends a rebellious witch, Eda, and an adorably tiny warrior, King. Despite not having magical abilities, Luz pursues her dream of becoming a witch by serving as Eda's apprentice at the Owl House and ultimately finds a new family in an unlikely setting.",
      popularity: 150.903,
      poster_path: "/zqjSex7DZn7p4dU7mMktdJ8zQV5.jpg",
      vote_average: 8.7,
      vote_count: 1280,
    },
    {
      backdrop_path: "/790rH1ByeDJg6VPwBFxdzxHRepI.jpg",
      first_air_date: "2019-04-06",
      genre_ids: [16, 35],
      id: 85990,
      name: "Hitoribocchi no Marumaruseikatsu",
      origin_country: ["JP"],
      original_language: "ja",
      original_name: "ひとりぼっちの○○生活",
      overview:
        "Hitori Bocchi suffers from extreme social anxiety, she's not good at talking to people, takes pretty extreme actions, is surprisingly adept at avoiding people, her legs cramp when she overexerts herself, gets full of herself when alone, will vomit when exposed to extreme tension and often comes up with plans. Now she is entering middle school and her only friend, Yawara Kai, is attending a different school. This leaves Bocchi alone, surrounded by new classmates with whom she must make friends before Kai will talk to her again.",
      popularity: 16.672,
      poster_path: "/btoTzCw3zmjRtB99g2M5Mw2GUQG.jpg",
      vote_average: 8.7,
      vote_count: 129,
    },
    {
      backdrop_path: "/iLR6tKvMu67oSK0DIgDutkPBaiy.jpg",
      first_air_date: "2018-07-08",
      genre_ids: [35, 16],
      id: 80539,
      name: "Asobi Asobase - workshop of fun -",
      origin_country: ["JP"],
      original_language: "ja",
      original_name: "あそびあそばせ",
      overview:
        'During recess, Olivia, a foreign transfer student who doesn\'t know English, plays a game of "look-the-other-way" with Hanako Honda, a loud-mouthed airhead. Their rowdy behavior spurs the ire of Kasumi Nomura, a deadpan loner constantly teased by her older sister for her tendency to lose games. Not willing to compete, Kasumi declines Olivia\'s offer to join the fun, but eventually gets involved anyway and dispenses her own brand of mischief. Soon, a strange friendship blossoms between the peculiar trio, and they decide to form the "Pastime Club," where they are free to resume their daily hijinks.\n\nWhether it be failing to learn English, trying desperately to become popular, or getting caught by teachers at the wrong time, school life will never be boring when these girls are up to their hilarious antics.',
      popularity: 19.859,
      poster_path: "/zWE3bnCILcRpfQCsxBkMsgcEjOE.jpg",
      vote_average: 8.7,
      vote_count: 118,
    },
    {
      backdrop_path: "/fCz519JJeXEtMfR4CmM9tR7rZOB.jpg",
      first_air_date: "2022-04-14",
      genre_ids: [10764],
      id: 154521,
      name: "The Kardashians",
      origin_country: ["US"],
      original_language: "en",
      original_name: "The Kardashians",
      overview:
        "The family you know and love is here with a brand new series, giving an all-access pass into their lives. Kris, Kourtney, Kim, Khloé, Kendall, and Kylie bring the cameras back to reveal the truth behind the headlines. From the intense pressures of running billion-dollar businesses to the hilarious joys of playtime and school drop-offs, this series brings viewers into the fold with a rivetingly honest story of love & life in the spotlight.",
      popularity: 70.336,
      poster_path: "/ntLiiyI2AVIVAtVKwUYqi36e3bM.jpg",
      vote_average: 8.7,
      vote_count: 1874,
    },
  ];

  const PopularSerie = [
    {
      backdrop_path: "/uDgy6hyPd82kOHh6I95FLtLnj6p.jpg",
      first_air_date: "2023-01-15",
      genre_ids: [18],
      id: 100088,
      name: "The Last of Us",
      origin_country: ["US"],
      original_language: "en",
      original_name: "The Last of Us",
      overview:
        "Twenty years after modern civilization has been destroyed, Joel, a hardened survivor, is hired to smuggle Ellie, a 14-year-old girl, out of an oppressive quarantine zone. What starts as a small job soon becomes a brutal, heartbreaking journey, as they both must traverse the United States and depend on each other for survival.",
      popularity: 3208.756,
      poster_path: "/uKvVjHNqB5VmOrdxqAt2F7J78ED.jpg",
      vote_average: 8.8,
      vote_count: 2771,
    },
    {
      backdrop_path: "/3n2TjKw3HrwDqgVgcynvantOfS3.jpg",
      first_air_date: "2023-01-04",
      genre_ids: [18, 10751],
      id: 215103,
      name: "Teri Meri Doriyaann",
      origin_country: ["IN"],
      original_language: "hi",
      original_name: "तेरी मेरी डोरियाँ",
      overview:
        "It’s hate at first sight for Sahiba and Angad! But destined to be together, their lives get intertwined by a marriage alliance, and a love-hate story ensues.",
      popularity: 1645.255,
      poster_path: "/4BHDmYiuSnNL3nqKIOzLJKYX4AN.jpg",
      vote_average: 6,
      vote_count: 1,
    },
    {
      backdrop_path: "/dLLafkr4khRj00fvQjZ46oPsY43.jpg",
      first_air_date: "2022-11-28",
      genre_ids: [18],
      id: 215315,
      name: "Rabb Se Hai Dua",
      origin_country: ["IN"],
      original_language: "hi",
      original_name: "Rabb Se Hai Dua",
      overview:
        "Dua and her husband are a perfect married couple in the eyes of their family. However, Dua’s life turns upside down when her husband seeks her permission to marry another woman.",
      popularity: 1634.266,
      poster_path: "/6ikbefd7VeopbBuGgioYMNU5bQj.jpg",
      vote_average: 10,
      vote_count: 1,
    },
    {
      backdrop_path: "/nTB21wfQPX1IirpGXTmxr2VsWTC.jpg",
      first_air_date: "1955-11-26",
      genre_ids: [],
      id: 221053,
      name: "Zeit im Bild",
      origin_country: ["DE"],
      original_language: "de",
      original_name: "Zeit im Bild",
      overview: "",
      popularity: 1510.289,
      poster_path: "/axK66NpM828m1vdBvsfYZaXadIp.jpg",
      vote_average: 7,
      vote_count: 2,
    },
    {
      backdrop_path: "/ymkFaEO0UdYXKIgcWZ23TlYIRD9.jpg",
      first_air_date: "2020-11-16",
      genre_ids: [18, 10766, 10751],
      id: 113218,
      name: "Imlie",
      origin_country: ["IN"],
      original_language: "hi",
      original_name: "इमली",
      overview:
        "All Imlie wanted was to create a name for herself in the city. But upon her arrival, she finds herself caught in the middle of Aditya and Malini's love story.",
      popularity: 1271.343,
      poster_path: "/brajFHvqeitbp7ifevWpFpirS4S.jpg",
      vote_average: 5.6,
      vote_count: 9,
    },
    {
      backdrop_path: "/3FLHePl9Y3n4BidLVjIA9qSRDOE.jpg",
      first_air_date: "2021-08-03",
      genre_ids: [10766],
      id: 130542,
      name: "Bhagya Lakshmi",
      origin_country: ["IN"],
      original_language: "hi",
      original_name: "Bhagya Lakshmi",
      overview:
        "Hailing from a middle-class family, Lakshmi’s life is upended when she realises that her marriage to Rishi Oberoi, an industrialist’s son, is a sham to keep his death at bay.",
      popularity: 1809.447,
      poster_path: "/7wuKrFvbX7kAIF0ctotARsqayPo.jpg",
      vote_average: 5.2,
      vote_count: 31,
    },
    {
      backdrop_path: "/6Lw54zxm6BAEKJeGlabyzzR5Juu.jpg",
      first_air_date: "2019-11-12",
      genre_ids: [10765, 10759, 18],
      id: 82856,
      name: "The Mandalorian",
      origin_country: ["US"],
      original_language: "en",
      original_name: "The Mandalorian",
      overview:
        "After the fall of the Galactic Empire, lawlessness has spread throughout the galaxy. A lone gunfighter makes his way through the outer reaches, earning his keep as a bounty hunter.",
      popularity: 1124.071,
      poster_path: "/eU1i6eHXlzMOlEq0ku1Rzq7Y4wA.jpg",
      vote_average: 8.5,
      vote_count: 8595,
    },
    {
      backdrop_path: "/xgZ9AhvXqi9aSDWzCpoC9JAkLPY.jpg",
      first_air_date: "2019-01-01",
      genre_ids: [35],
      id: 85425,
      name: "Dear Heirs",
      origin_country: ["HU"],
      original_language: "hu",
      original_name: "Drága örökösök",
      overview:
        "Hungarian remake of the Bulgarian series about a disconnect family living together in order to get an inheritance.",
      popularity: 1637.058,
      poster_path: "/xDOUahrwEsgDlejXjZLc9lOljSx.jpg",
      vote_average: 5.3,
      vote_count: 7,
    },
    {
      backdrop_path: "/gQxaF79LUTtopdYHsuS8lUr9rvF.jpg",
      first_air_date: "2021-11-14",
      genre_ids: [18, 80],
      id: 97951,
      name: "Mayor of Kingstown",
      origin_country: ["US"],
      original_language: "en",
      original_name: "Mayor of Kingstown",
      overview:
        "In a small Michigan town where the business of incarceration is the only thriving industry, the McClusky family are the power brokers between the police, criminals, inmates, prison guards and politicians in a city completely dependent on prisons and the prisoners they contain.",
      popularity: 837.363,
      poster_path: "/86OUOPulMiM8rjrQSt4KMev7UAa.jpg",
      vote_average: 8.2,
      vote_count: 139,
    },
    {
      backdrop_path: "/t2rAdgjSh0WYbXzdOB5zTDqzdCI.jpg",
      first_air_date: "2022-11-02",
      genre_ids: [18],
      id: 213713,
      name: "Faltu",
      origin_country: ["IN"],
      original_language: "hi",
      original_name: "Faltu",
      overview:
        "What's in a name? Amidst the arid landscape of Rajasthan, a young woman with dreamy eyes struggles to prove her worth.",
      popularity: 1401.267,
      poster_path: "/lgyFuoXs7GvKJN0mNm7z7OMOFuZ.jpg",
      vote_average: 5.3,
      vote_count: 13,
    },
    {
      backdrop_path: "/caGVr9Il2gj8bN4ow6qsLm60TxM.jpg",
      first_air_date: "2005-03-27",
      genre_ids: [18],
      id: 1416,
      name: "Grey's Anatomy",
      origin_country: ["US"],
      original_language: "en",
      original_name: "Grey's Anatomy",
      overview:
        "Follows the personal and professional lives of a group of doctors at Seattle’s Grey Sloan Memorial Hospital.",
      popularity: 958.587,
      poster_path: "/daSFbrt8QCXV2hSwB0hqYjbj681.jpg",
      vote_average: 8.3,
      vote_count: 8988,
    },
    {
      backdrop_path: "/iN9uULLaSx7h21tcR9io2dnARjw.jpg",
      first_air_date: "2013-04-15",
      genre_ids: [80, 18, 10766],
      id: 44953,
      name: "The Lord of the Skies",
      origin_country: ["MX"],
      original_language: "es",
      original_name: "El señor de los cielos",
      overview:
        "Set in the 1990s, these are the life and times of Amado Carrillo Fuentes, a man who became the head of the Juárez cartel. Nicknamed “El Señor de los Cielos” (Lord of the Skies) because of the large fleet of airplanes he used to transport drugs, he was also known for washing more than $200 million through Colombia to finance his huge fleet. He is described as the most powerful drug trafficker of his time.",
      popularity: 846.584,
      poster_path: "/Ag7VUdnrRz5Qpq3Yn3E5OCvFnu0.jpg",
      vote_average: 7.9,
      vote_count: 2462,
    },
    {
      backdrop_path: null,
      first_air_date: "2021-10-27",
      genre_ids: [18],
      id: 197109,
      name: "Yeh Rishta Kya Kehlata Hai",
      origin_country: ["IN"],
      original_language: "hi",
      original_name: "ये रिश्ता क्या कहलाता है",
      overview:
        "A personal tragedy creates a rift in Abhimanyu and Akshara's marital life. Years later, when destiny offers a second chance, will the duo embrace love?",
      popularity: 1201.176,
      poster_path: "/6ZfiG4P7jivJV0wgcNMSiS2Owhh.jpg",
      vote_average: 4.9,
      vote_count: 16,
    },
    {
      backdrop_path: "/jIV5weV19wH02rnuWyMtYI4dYC8.jpg",
      first_air_date: "2023-02-13",
      genre_ids: [10759, 35, 18],
      id: 215803,
      name: "Batang Quiapo",
      origin_country: ["PH"],
      original_language: "tl",
      original_name: "Batang Quiapo",
      overview:
        "A young man rises to be one of the biggest outlaws in the neighborhood while he navigates his way in life to survive in Quiapo. Hoping to earn the affection of his parents, his feat draws him closer to the truth about his identity.",
      popularity: 825.888,
      poster_path: "/9McqS8mgMf5NJCAKZIY6J1oOl8y.jpg",
      vote_average: 6.3,
      vote_count: 3,
    },
    {
      backdrop_path: "/iHSwvRVsRyxpX7FE7GbviaDvgGZ.jpg",
      first_air_date: "2022-11-23",
      genre_ids: [10765, 9648, 35],
      id: 119051,
      name: "Wednesday",
      origin_country: ["US"],
      original_language: "en",
      original_name: "Wednesday",
      overview:
        "Wednesday Addams is sent to Nevermore Academy, a bizarre boarding school where she attempts to master her psychic powers, stop a monstrous killing spree of the town citizens, and solve the supernatural mystery that affected her family 25 years ago — all while navigating her new relationships.",
      popularity: 811.174,
      poster_path: "/9PFonBhy4cQy7Jz20NpMygczOkv.jpg",
      vote_average: 8.6,
      vote_count: 6681,
    },
    {
      backdrop_path: "/qcpC9lv6VLL4Zw45EveYELyje1w.jpg",
      first_air_date: "2020-10-05",
      genre_ids: [18, 10766, 10751],
      id: 111453,
      name: "Ghum Hai Kisi Ke Pyaar Mein",
      origin_country: ["IN"],
      original_language: "hi",
      original_name: "घुम है किसिकी प्यार में",
      overview:
        "Virat sacrifices his love to honour the promise he made to a dying man. Trapped between the past and the present, will he find love beyond the chains of duty?",
      popularity: 1061.514,
      poster_path: "/uNjnoT3RChs2r7O9pDyx7TNBvIj.jpg",
      vote_average: 5.9,
      vote_count: 32,
    },
    {
      backdrop_path: "/gFkHcIh7iE5G0oVOgpmY8ONQjhl.jpg",
      first_air_date: "2014-10-07",
      genre_ids: [18, 10765],
      id: 60735,
      name: "The Flash",
      origin_country: ["US"],
      original_language: "en",
      original_name: "The Flash",
      overview:
        'After a particle accelerator causes a freak storm, CSI Investigator Barry Allen is struck by lightning and falls into a coma. Months later he awakens with the power of super speed, granting him the ability to move through Central City like an unseen guardian angel. Though initially excited by his newfound powers, Barry is shocked to discover he is not the only "meta-human" who was created in the wake of the accelerator explosion -- and not everyone is using their new powers for good. Barry partners with S.T.A.R. Labs and dedicates his life to protect the innocent. For now, only a few close friends and associates know that Barry is literally the fastest man alive, but it won\'t be long before the world learns what Barry Allen has become...The Flash.',
      popularity: 767.159,
      poster_path: "/rg8N7x27Ef6PvlIiioLStf9ZaIO.jpg",
      vote_average: 7.8,
      vote_count: 10295,
    },
    {
      backdrop_path: "/3r6rV0tGI2BtVgqc4e65Gh4hVXO.jpg",
      first_air_date: "2023-02-20",
      genre_ids: [10766],
      id: 220992,
      name: "Impossible Love",
      origin_country: ["MX"],
      original_language: "es",
      original_name: "El amor invencible",
      overview:
        "After losing all her loved ones fifteen years ago and believing her babies were killed at the hands of the father of her first love, Leona Bravo (Angelique Boyer) embarks on a journey of justice against all those who hurt her. In this process, Leona discovers that her children are actually alive and is reunited with an old friend with whom she finds true love. As a result, she will be torn between her desire for justice and rebuilding her bond with her two children, as well as regaining her faith in love.",
      popularity: 762.612,
      poster_path: "/5ea9hJqaImtakNpeet9DI2yhy4g.jpg",
      vote_average: 6,
      vote_count: 2,
    },
    {
      backdrop_path: "/7vCSrzwqS5PEm0i5mHlkDfjHcnX.jpg",
      first_air_date: "2022-12-30",
      genre_ids: [18],
      id: 136283,
      name: "The Glory",
      origin_country: ["KR"],
      original_language: "ko",
      original_name: "더 글로리",
      overview:
        "After a childhood marked by pain and violence, a woman puts a carefully planned revenge scheme in motion.",
      popularity: 700.208,
      poster_path: "/6jOpyXVzQyYL4QB12VRpHUxdwg1.jpg",
      vote_average: 8.6,
      vote_count: 277,
    },
    {
      backdrop_path: "/iQ6ANV7F7I6Lc8rTLSEwDkOO37Q.jpg",
      first_air_date: "1988-05-02",
      genre_ids: [],
      id: 221056,
      name: "Tirol Heute",
      origin_country: ["DE"],
      original_language: "de",
      original_name: "Tirol Heute",
      overview: "",
      popularity: 1477.087,
      poster_path: null,
      vote_average: 5,
      vote_count: 1,
    },
  ];

  return (
    <SerieContext.Provider value={{ PopularSerie, TopSerie }}>
      {children}
    </SerieContext.Provider>
  );
};

export default SerieProvider;
